import { t } from '@lingui/core/macro';
import { object, string, boolean } from 'yup';
export const makeSchema = () => object().shape({
    name: string().required(t({ message: 'Name is required', comment: 'Validation message for name field' })),
    description: string(),
    isPublic: boolean(),
});
